import styled from 'styled-components';
import { HeaderSubnavLinkStyle } from 'components/Header/HeaderSubnavLink';

const activeClassName = 'nav-item-active';

export const HeaderSubnavButton = styled.div.attrs({ activeClassName })`
    ${HeaderSubnavLinkStyle}
`;
